import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.nav`
  min-width: 220px;
  background-color: var(--backgroundWhite);
  box-shadow: 1px 1px 14px 2px rgba(0, 0, 0, 0.15);
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.15));
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  position: absolute;
  right: -32px;
  top: 96px;
  padding: 28px;
  z-index: 10;

  &::before {
    content: '';
    border-style: solid;

    border-color: #fff transparent;
    border-width: 0px 8px 8px 8px;
    position: absolute;
    bottom: 100%;
    left: 70%;
    transform: translateX(-50%);
  }

  @media (max-width: 768px) {
    top: -320px;
    right: 0;
    
    &::before {
      width: 0;
      height: 0;
      left: 90%;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid #fff;
      bottom: -14px;
    }
  }
`;

export const ProfileLinks = styled(Link)`
  text-decoration: none;

  font-size: var(--font-medium);
  color: var(--dark-gray);

  & + a {
    margin-top: 28px;
  }

  &:hover {
    text-decoration: underline;
  }
`;

export const ExitButton = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: var(--font-medium);
  color: var(--secondary-color);
  background: var(--light-gray) !important;
  border: none;
  border-radius: 30px;

  max-width: 86px;
  margin-top: 38px;
  padding: 4px 12px;
  align-self: center;

  svg {
    margin: 0 8px 4px 0;
  }
`;
